import React, { useState } from "react";
import { PageMode } from "utils/constant";
import { useEffect } from "react";
import TableComponent from "./components/TableComponent";
import FormComponent from "./components/FormComponent";

const KnowlesiLab = () => {
  const [pageMode, setPageMode] = useState(PageMode.view);

  useEffect(() => {
    document.title = "SISMAL | Knowlesi Lab";
  }, []);

  const changePageMode = (mode) => {
    setPageMode(mode);
  };

  return (
    <div className="dashboard-wrapper">
      {pageMode === PageMode.view && (
        <TableComponent changeMode={changePageMode} />
      )}
      {(pageMode === PageMode.add || pageMode === PageMode.edit) && (
        <FormComponent changeMode={changePageMode} pageMode={pageMode} />
      )}
    </div>
  );
};

export default KnowlesiLab;
